module.exports = __webpack_public_path__ + "img/DE03621.b1bfcff7.png";